/**
 * Rect object.
 *
 * @see https://developer.mozilla.org/en-US/docs/Web/API/SVGRect
 */
export default class SVGRect {
	public x = 0;
	public y = 0;
	public width = 0;
	public height = 0;
}
